import React, { FC } from 'react';
import History from 'src/components/History';
import { ConstantsCodesObjectType } from 'src/types/constantsCodes';
import { ReceivingChangelogType } from 'src/types/receivingDetail';
import {
    historyPackagingUpdates,
    historyProductUpdates,
    historyReceivingFilesUpdates,
    historyUpdates,
    historyUpdatesSkladonUser,
    historyCreateHiddenKeys,
} from './constants';
import translateUrgentValue from 'src/utils/translateUrgentValue';

export interface HistoryPropsType {
    changelog: ReceivingChangelogType | null;
    receivingStatusCodesObject: ConstantsCodesObjectType;
    receivingUrgentCodesObject: ConstantsCodesObjectType;
    receivingDeliveryTypeCodesObject: ConstantsCodesObjectType;
    productTypeCodesObject: ConstantsCodesObjectType;
    receivingPackingTypeCodesObject: ConstantsCodesObjectType;
    receivingPalletCodesObject: ConstantsCodesObjectType;
    lineStateCodesObject: ConstantsCodesObjectType;
    driverCompanyCodesObject: ConstantsCodesObjectType;
    receivingPriorityCodesObject: ConstantsCodesObjectType;
    receivingTypeCodesObject: ConstantsCodesObjectType;
    incotermsCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
    skladonUser?: number;
}

const HistoryBlock: FC<HistoryPropsType> = (props) => {
    return (
        <History
            updates={props.changelog?.updates}
            updateKeys={props.skladonUser ? historyUpdatesSkladonUser : historyUpdates}
            updateItemsKeys={{
                PRODUCTS: { requiredItems: ['SKU'], itemKeys: historyProductUpdates },
                PACKAGINGS: { itemKeys: historyPackagingUpdates },
                RECEIVING_FILES: {
                    requiredItems: ['ORIGINAL_FILE_NAME'],
                    itemKeys: historyReceivingFilesUpdates
                },
            }}
            keyCodes={{
                STATUS: props.receivingStatusCodesObject,
                DELIVERY_TYPE: props.receivingDeliveryTypeCodesObject,
                DRIVER_COMPANY: props.driverCompanyCodesObject,
                PRIORITY: props.receivingPriorityCodesObject,
                RECEIVING_TYPE: props.receivingTypeCodesObject,
                INCOTERMS: props.incotermsCodesObject,
                DUTY: props.boolNumberCodesObject,
                PHOTO_DOCUMENTATION_TAKEN: props.boolNumberCodesObject,
            }}
            keyCallbacks={{
                URGENT: (value) => translateUrgentValue(String(value)),
            }}
            keyItemsCodes={{
                PRODUCTS: {
                    LINE_STATE: props.lineStateCodesObject,
                },
                PACKAGINGS: {
                    PACKAGING_TYPE: props.receivingPackingTypeCodesObject,
                    PALLET: props.receivingPalletCodesObject,
                },
            }}
            translatePrefix="receivingDetail"
            createHiddenKeys={historyCreateHiddenKeys}
        />
    );
};

export default HistoryBlock;
